import {
  Button,
  Col,
  Form,
  Row,
  Input,
  message,
  DatePicker,
  Select,
} from "antd";
import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  companyService,
  purchaseOrderService,
  referenceService,
} from "_services";
import { ReferenceTypeCodes } from "_helpers";

function PurchaseOrderSearch(props) {
  const [suppliers, setSuppliers] = useState([]);
  const [form] = Form.useForm();
  const [purchaseOrderTypes, setPurchaseOrderTypes] = useState([]);

  useEffect(() => {
    getSuppliers();
    getPurchaseOrderTypes();
  }, []);

  const getSuppliers = () => {
    companyService
      .getSuggestion("?companyTypeCodes=CON,BUY")
      .then((x) => {
        setSuppliers(x.content);
      })
      .catch((error) => {
        message.error(`${error}`);
      });
  };

  const getPurchaseOrderTypes = () => {
    referenceService
      .getAllReferenceDataByTypeCode(ReferenceTypeCodes.PO_TYPE)
      .then((x) => {
        setPurchaseOrderTypes(x.content);
      })
      .catch((errorInfo) => {
        message.error(`${errorInfo}`);
      });
  };

  const onFinish = (values) => {
    props.showSearchLoading(true);
    let searchParams = "";
    if (values.purchaseOrderNumber) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `orderNumber=${encodeURIComponent(
        values.purchaseOrderNumber
      )}`;
    }

    if (values.orderDateRange) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `fromDate=${encodeURIComponent(
        moment(values.orderDateRange[0]).startOf("day").format("YYYY-MM-DD")
      )}&toDate=${moment(values.orderDateRange[1])
        .startOf("day")
        .format("YYYY-MM-DD")}`;
    }

    if (values.supplierId) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `supplierId=${encodeURIComponent(values.supplierId)}`;
    }

    if (values.consigneeId) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `consigneeId=${encodeURIComponent(values.consigneeId)}`;
    }

    if (values.purchaseOrderTypeId) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `purchaseOrderTypeId=${encodeURIComponent(
        values.purchaseOrderTypeId
      )}`;
    }
    purchaseOrderService
      .search(searchParams)
      .then((data) => {
        props.onSearchResults(
          data.content,
          data.pagination.totalRecords,
          searchParams
        );
      })
      .catch((error) => {
        message.error(`${error}`);
        props.onSearchResults([]);
      });
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
      className="search-form"
    >
      <Row gutter={24}>
        <Col span={6}>
          <Form.Item name="purchaseOrderNumber" label="Order Number">
            <Input.Search placeholder="Order Number" allowClear />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="orderDateRange" label="Order Date">
            <DatePicker.RangePicker
              ranges={{
                Today: [moment(), moment()],
                "This Month": [
                  moment().startOf("month"),
                  moment().endOf("month"),
                ],
              }}
            />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item name="supplierId" label="Supplier Company">
            <Select
              showSearch
              allowClear
              showArrow={false}
              optionFilterProp="children"
              placeholder="Supplier Company"
            >
              {suppliers.map((t) => (
                <Select.Option value={t.id} key={t.id}>
                  {t.name} ({t.code})
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item name="consigneeId" label="Consignee / Buyer">
            <Select
              showSearch
              allowClear
              showArrow={false}
              optionFilterProp="children"
              placeholder="Consignee / Buyer"
            >
              {suppliers.map((t) => (
                <Select.Option value={t.id} key={t.id}>
                  {t.name} ({t.code})
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="purchaseOrderTypeId" label="Purchase Order Type">
            <Select
              showSearch
              allowClear
              showArrow={false}
              optionFilterProp="children"
              placeholder="Purchase Order Type"
            >
              {purchaseOrderTypes.length > 0 &&
                purchaseOrderTypes.map((t) => (
                  <Select.Option value={t.id} key={t.id}>
                    {t.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}></Col>
        <Col span={6}></Col>
        <Col span={6}></Col>
        <Col span={6}></Col>
        <Col span={6}></Col>
        <Col span={6}></Col>
        <Col span={6} style={{ textAlign: "right" }}>
          <div>
            <Button type="primary" htmlType="submit">
              Search
            </Button>
            <Button
              style={{ margin: "0 8px" }}
              onClick={() => {
                form.resetFields();
                onFinish({});
              }}
            >
              Clear
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  );
}

export default PurchaseOrderSearch;
